import { defineComponent as r, createBlock as a, openBlock as n, unref as p, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const x = /* @__PURE__ */ r({
  name: "IconExport",
  __name: "IconExport",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (n(), a(p(s), l(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M7.53 11.53a.75.75 0 0 1-1.06 0L3.823 8.884a1.25 1.25 0 0 1 0-1.768L6.47 4.47a.75.75 0 0 1 1.06 1.06L5.81 7.25H17a.75.75 0 0 1 0 1.5H5.81l1.72 1.72a.75.75 0 0 1 0 1.06M6.25 16A.75.75 0 0 0 7 16.75h11.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l2.647-2.646a1.25 1.25 0 0 0 0-1.768L17.53 12.47a.75.75 0 0 0-1.06 1.06l1.72 1.72H7A.75.75 0 0 0 6.25 16" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  x as default
};
